import { useFormikContext } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

interface FormMultiSelectProps {
    name: string;
    placeholder?: string;
    options: FormMultiSelectOption[];
    className?: string;
    errorClassname?: string;
    emptyMessage?: string;
}

interface FormMultiSelectOption {
    id: string;
    label: string;
}

function FormMultiSelect({ name, placeholder, options, className = "col-12", errorClassname = "text-danger mt-1",
    emptyMessage = "Brak dostępnych opcji" }: FormMultiSelectProps) {
    const formik = useFormikContext<any>();
    const values = formik.values[name] as string[] | undefined || [];
    const errors = formik.errors[name] as string[] | string | undefined;
    const touched = formik.touched[name] as boolean | undefined;

    const handleChange = (selectedId: string) => {
        if (values.includes(selectedId)) {
            const updated = values.filter((id: string) => id !== selectedId);
            formik.setFieldValue(name, updated);
        } else {
            formik.setFieldValue(name, [...values, selectedId]);
        }
    };

    return (
        <div className={className}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "0.7rem" }}>
                <span style={{ fontSize: "1.2rem", color: "#dc3545", fontWeight: "bold", minWidth: "1.5rem", marginLeft: "0.6rem" }}>*</span>
                <label style={{ marginBottom: 0}}>{placeholder}:</label>
            </div>
            <Form.Group className="ms-5">
                {options.length === 0 ? (
                    <div className="text-muted">{emptyMessage}</div>
                ) : (
                    options.map((option) => (
                        <Form.Check
                            key={option.id}
                            type="checkbox"
                            id={`${name}-${option.id}`}
                            label={option.label}
                            checked={values.includes(option.id)}
                            onChange={() => handleChange(option.id)}
                            onBlur={() => formik.setFieldTouched(name, true)}
                        />
                    ))
                )}
            </Form.Group>

            {errors && (touched || formik.submitCount > 0) && (
                <div className={errorClassname + " ms-4"}>
                    {Array.isArray(errors) ? errors[0] : errors}
                </div>
            )}
        </div>
    );
}

export default FormMultiSelect;
